import Font from "./enum/Font";

export interface FontDefinition {
    id: Font
    family: string
    weights: number[]
}

export const fonts: FontDefinition[] = [
    { id: Font.ALEGREYA, family: 'Alegreya', weights: [400, 700] },
    { id: Font.ALEGREYA_SANS, family: 'Alegreya Sans', weights: [400, 700] },
    { id: Font.ALICE, family: 'Alice', weights: [400] },
    { id: Font.AMATIC_SC, family: 'Amatic SC', weights: [400] },
    { id: Font.AMIKO, family: 'Amiko', weights: [400, 700] },
    { id: Font.AMIRI, family: 'Amiri', weights: [400, 700] },
    { id: Font.ANNIE_USE_YOUR_TELESCOPE, family: 'Annie Use Your Telescope', weights: [400] },
    { id: Font.ARCHITECTS_DAUGHTER, family: 'Architects Daughter', weights: [400] },
    { id: Font.ARCHIVO_NARROW, family: 'Archivo Narrow', weights: [400, 700] },
    { id: Font.AZERET_MONO, family: 'Azeret Mono', weights: [400, 700] },
    { id: Font.BAD_SCRIPT, family: 'Bad Script', weights: [400] },
    { id: Font.BALOO_2, family: 'Baloo 2', weights: [400, 700] },
    { id: Font.BIORHYME, family: 'BioRhyme', weights: [400, 700] },
    { id: Font.BODONI_MODA, family: 'Bodoni Moda', weights: [400, 700] },
    { id: Font.BUNGEE_INLINE, family: 'Bungee Inline', weights: [400] },
    { id: Font.CARDO, family: 'Cardo', weights: [400, 700] },
    { id: Font.CARTER_ONE, family: 'Carter One', weights: [400] },
    { id: Font.CAVEAT, family: 'Caveat', weights: [400, 700] },
    { id: Font.CAVEAT_BRUSH, family: 'Caveat Brush', weights: [400] },
    { id: Font.CEDARVILLE_CURSIVE, family: 'Cedarville Cursive', weights: [400] },
    { id: Font.CEVICHE_ONE, family: 'Ceviche One', weights: [400] },
    { id: Font.CHIVO, family: 'Chivo', weights: [400, 700] },
    { id: Font.COMING_SOON, family: 'Coming Soon', weights: [400] },
    { id: Font.CORBEN, family: 'Corben', weights: [400] },
    { id: Font.CORMORANT, family: 'Cormorant', weights: [400, 700] },
    { id: Font.COURGETTE, family: 'Courgette', weights: [400] },
    { id: Font.DEKKO, family: 'Dekko', weights: [400] },
    { id: Font.DM_SANS, family: 'DM Sans', weights: [400, 700] },
    { id: Font.EB_GARAMOND, family: 'EB Garamond', weights: [400, 700] },
    { id: Font.ECZAR, family: 'Eczar', weights: [400, 700] },
    { id: Font.ERICA_ONE, family: 'Erica One', weights: [400] },
    { id: Font.EXPLETUS_SANS, family: 'Expletus Sans', weights: [400, 700] },
    { id: Font.FIRA_SANS, family: 'Fira Sans', weights: [400, 700] },
    { id: Font.FREDOKA_ONE, family: 'Fredoka One', weights: [400] },
    { id: Font.FRUKTUR, family: 'Fruktur', weights: [400] },
    { id: Font.GIVE_YOU_GLORY, family: 'Give You Glory', weights: [400] },
    { id: Font.GOCHI_HAND, family: 'Gochi Hand', weights: [400] },
    { id: Font.HANDLEE, family: 'Handlee', weights: [400] },
    { id: Font.HOMEMADE_APPLE, family: 'Homemade Apple', weights: [400] },
    { id: Font.IBM_PLEX_SANS, family: 'IBM Plex Sans', weights: [400, 700] },
    { id: Font.ICEBERG, family: 'Iceberg', weights: [400] },
    { id: Font.INCONSOLATA, family: 'INCONSOLATA', weights: [400, 700] },
    { id: Font.INDIE_FLOWER, family: 'Indie Flower', weights: [400] },
    { id: Font.INKNUT_ANTIQUA, family: 'Inknut Antiqua', weights: [400, 700] },
    { id: Font.INTER, family: 'Inter', weights: [400, 700] },
    { id: Font.JUST_ANOTHER_HAND, family: 'Just Another Hand', weights: [400] },
    { id: Font.JUST_ME_AGAIN_DOWN_HERE, family: 'Just Me Again Down Here', weights: [400] },
    { id: Font.KALAM, family: 'Kalam', weights: [400, 700] },
    { id: Font.KARLA, family: 'Karla', weights: [400, 700] },
    { id: Font.KAUSHAN_SCRIPT, family: 'Kaushan Script', weights: [400] },
    { id: Font.KAVOON, family: 'Kavoon', weights: [400] },
    { id: Font.KENIA, family: 'Kenia', weights: [400] },
    { id: Font.KRISTI, family: 'Kristi', weights: [400] },
    { id: Font.LA_BELLE_AURORE, family: 'La Belle Aurore', weights: [400] },
    { id: Font.LATO, family: 'Lato', weights: [400, 700] },
    { id: Font.LIBRE_BASKERVILLE, family: 'Libre Baskerville', weights: [400, 700] },
    { id: Font.LIBRE_FRANKLIN, family: 'Libre Franklin', weights: [400, 700] },
    { id: Font.LILITA_ONE, family: 'Lilita One', weights: [400] },
    { id: Font.LORA, family: 'Lora', weights: [400, 700] },
    { id: Font.LUSTRIA, family: 'Lustria', weights: [400] },
    { id: Font.MANROPE, family: 'Manrope', weights: [400, 700] },
    { id: Font.MARCK_SCRIPT, family: 'Marck Script', weights: [400] },
    { id: Font.MERIENDA, family: 'Merienda', weights: [400, 700] },
    { id: Font.MERRIWEATHER, family: 'Merriweather', weights: [400, 700] },
    { id: Font.MONOTON, family: 'Monoton', weights: [400] },
    { id: Font.MONTSERRAT, family: 'Montserrat', weights: [400, 700] },
    { id: Font.MUKTA, family: 'Mukta', weights: [400, 700] },
    { id: Font.MULISH, family: 'Mulish', weights: [400, 700] },
    { id: Font.NEUCHA, family: 'Neucha', weights: [400] },
    { id: Font.NEUTON, family: 'Neuton', weights: [400, 700] },
    { id: Font.NOTHING_YOU_COULD_DO, family: 'Nothing You Could Do', weights: [400] },
    { id: Font.NOTO_SANS, family: 'Noto Sans', weights: [400, 700] },
    { id: Font.NUNITO, family: 'Nunito', weights: [400, 700] },
    { id: Font.NUNITO_SANS, family: 'Nunito Sans', weights: [400, 700] },
    { id: Font.OI, family: 'Oi', weights: [400] },
    { id: Font.OPEN_SANS, family: 'Open Sans', weights: [400, 700] },
    { id: Font.OSWALD, family: 'Oswald', weights: [400, 700] },
    { id: Font.OXYGEN, family: 'Oxygen', weights: [400, 700] },
    { id: Font.PANGOLIN, family: 'Pangolin', weights: [400] },
    { id: Font.PATRICK_HAND, family: 'Patrick Hand', weights: [400] },
    { id: Font.PATRICK_HAND_SC, family: 'Patrick Hand SC', weights: [400] },
    { id: Font.PERMANENT_MARKER, family: 'Permanent Marker', weights: [400] },
    { id: Font.PIAZZOLLA, family: 'Piazzolla', weights: [400, 700] },
    { id: Font.PLAYFAIR_DISPLAY, family: 'Playfair Display', weights: [400, 700] },
    { id: Font.POPPINS, family: 'Poppins', weights: [400, 700] },
    { id: Font.PROZA_LIBRE, family: 'Proza Libre', weights: [400, 700] },
    { id: Font.PT_SANS, family: 'PT Sans', weights: [400, 700] },
    { id: Font.PT_SERIF, family: 'PT Serif', weights: [400, 700] },
    { id: Font.QUICKSAND, family: 'Quicksand', weights: [400, 700] },
    { id: Font.RAKKAS, family: 'Rakkas', weights: [400] },
    { id: Font.RALEWAY, family: 'Raleway', weights: [400, 700] },
    { id: Font.RALEWAY_DOTS, family: 'Raleway Dots', weights: [400] },
    { id: Font.RAMMETTO_ONE, family: 'Rammetto One', weights: [400] },
    { id: Font.REENIE_BEANIE, family: 'Reenie Beanie', weights: [400] },
    { id: Font.ROBOTO, family: 'Roboto', weights: [400, 700] },
    { id: Font.ROBOTO_CONDENSED, family: 'Roboto Condensed', weights: [400, 700] },
    { id: Font.ROBOTO_SLAB, family: 'Roboto Slab', weights: [400, 700] },
    { id: Font.ROCK_SALT, family: 'Rock Salt', weights: [400] },
    { id: Font.RUBIK, family: 'Rubik', weights: [400, 700] },
    { id: Font.SEAWEED_SCRIPT, family: 'Seaweed Script', weights: [400] },
    { id: Font.SHADOWS_INTO_LIGHT, family: 'Shadows Into Light', weights: [400] },
    { id: Font.SHADOWS_INTO_LIGHT_TWO, family: 'Shadows Into Light Two', weights: [400] },
    { id: Font.SHRIKHAND, family: 'Shrikhand', weights: [400] },
    { id: Font.SOURCE_SANS_PRO, family: 'Source Sans Pro', weights: [400, 700] },
    { id: Font.SOURCE_SERIF_PRO, family: 'Source Serif Pro', weights: [400, 700] },
    { id: Font.SPACE_GROTESK, family: 'Space Grotesk', weights: [400, 700] },
    { id: Font.SPACE_MONO, family: 'Space Mono', weights: [400, 700] },
    { id: Font.SPECTRAL, family: 'Spectral', weights: [400, 700] },
    { id: Font.SWANKY_AND_MOO_MOO, family: 'Swanky and Moo Moo', weights: [400] },
    { id: Font.SYNE, family: 'Syne', weights: [400, 700] },
    { id: Font.UBUNTU, family: 'Ubuntu', weights: [400, 700] },
    { id: Font.ULTRA, family: 'Ultra', weights: [400] },
    { id: Font.VOLLKORN, family: 'Vollkorn', weights: [400, 700] },
    { id: Font.WALTER_TURNCOAT, family: 'Walter Turncoat', weights: [400] },
    { id: Font.WIRE_ONE, family: 'Wire One', weights: [400] },
    { id: Font.WORK_SANS, family: 'Work Sans', weights: [400, 700] },
    { id: Font.YATRA_ONE, family: 'Yatra One', weights: [400] },
    { id: Font.BERNIER_DISTRESSED, family: 'BERNIER Distressed', weights: [400] },
    { id: Font.BUILT_TITLING, family: 'Built Titling', weights: [250, 300, 400, 600, 700] },
    { id: Font.AGRANDIR, family: 'PP Agrandir', weights: [400, 700]},
    { id: Font.DK_LEMON_YELLOW_SUN, family: 'DK Lemon Yellow Sun', weights: [400]},
    { id: Font.SUSHITO, family: 'Sushito', weights: [400]}
]
